<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h4></h4>
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tbody>
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td>
              <input
                type="text"
                class="form-control"
                id="nombreBusqueda"
                name="nombreBusqueda"
                v-model="nombreBusqueda"
                style="width: 500px; text-transform: uppercase"
                required
              />
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPagina(1)"
                title="Buscar registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >search</i
                >
                Buscar
              </button>
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                @click.prevent="getDataPaginaTodos(1)"
                title="Todos los registros"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: blue; cursor: pointer"
                  >auto_awesome_motion</i
                >
              </button>
            </td>
            <td>
              <button
                type="submit"
                class="btn btn-light"
                data-bs-toggle="modal"
                data-bs-target="#ventanaModal"
                @click="abrirModalCrear"
                title="Nuevo registro"
              >
                <i
                  class="material-icons"
                  style="font-size: 24px; color: green; cursor: pointer"
                  >add_box</i
                >
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">PerfilNombre</th>
          <th scope="col">ConsejoFechaReg</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="consperf in datosPaginados" :key="consperf.idConsPerf">
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirModalEditar(consperf.idConsPerf)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: orangered; cursor: pointer"
              @click="abrirEditar(consperf.idConsPerf)"
              title="Editar"
              >edit_square</i
            >
          </td>
          <td>{{ consperf.perfilNombre }}</td>
          <td>
            {{ getFormattedDate(consperf.consejoFechaReg, "DD/MM/YYYY") }}
          </td>
          <td>
            <i
              class="material-icons"
              style="font-size: 16px; color: red; cursor: pointer"
              @click="deleteConsPerf(consperf.idConsPerf)"
              title="Borrar"
              >delete</i
            >
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPagina(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label for="idConsPerf" class="form-label"
                      >IdConsPerf</label
                    >
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idConsPerf"
                      name="idConsPerf"
                      v-model="datoConsPerf.idConsPerf"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Perfil -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idPerfil" class="form-label"> Perfil</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idPerfil"
                      name="idPerfil"
                      v-model="datoConsPerf.idPerfil"
                    >
                      <option
                        v-for="perfil in perfils"
                        :value="perfil.idPerfil"
                        :key="perfil.idPerfil"
                      >
                        {{ perfil.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Perfil -->
              <!-- Botón Lista de Valores  Consejo -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="idConsejo" class="form-label"> Consejo</label>
                  </div>
                  <div class="col-10">
                    <select
                      class="form-control"
                      id="idConsejo"
                      name="idConsejo"
                      v-model="datoConsPerf.idConsejo"
                    >
                      <option
                        v-for="consejo in consejos"
                        :value="consejo.idConsejo"
                        :key="consejo.idConsejo"
                      >
                        {{ consejo.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <!-- Botón Lista de Valores  Consejo -->
            </div>
          </form>
          <div class="modal-footer">
            <!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarConsPerf"
              v-if="btnCrear"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >Guardar
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="actualizarConsPerf"
              v-if="btnEditar"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import config from '@/config';
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat from "@/modules/dateFormat.js";


import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      consperfs: [],
      datoConsPerf: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      perfils: [],
      consejos: [],
      showModalHelp: false,
      estiloImagen: {
        width: "200px",
        height: "200px",
      },
    };
  },
  mounted() {
    this.getDataPaginaTodos(this.paginaActual);
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.fetchPerfils();
    this.fetchConsejos();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    totalPaginas() {
      return Math.ceil(this.consperfs.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwconsperfs/nombre/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.consperfs = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.consperfs.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwconsperfs").then((response) => {
        this.consperfs = response.data.reverse();
        this.paginaActual = noPagina;
        this.datosPaginados = [];
        let ini = noPagina * this.elementosPorPagina - this.elementosPorPagina;
        let fin = noPagina * this.elementosPorPagina;
        this.datosPaginados = this.consperfs.slice(ini, fin);
      });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarForm() {
      const requiredFields = ["idPerfil", "idConsejo"];
      const requiredFieldsText = ["idPerfil", "idConsejo"];
      return validarForm(this.datoConsPerf, requiredFields, requiredFieldsText);
    },
    async guardarConsPerf() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/consperfs",
            this.datoConsPerf
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "ConsPerf creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async actualizarConsPerf() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/consperfs",
            this.datoConsPerf
          );
          $("#ventanaModal").modal("hide");
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ConsPerf creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoConsPerf = {};
      this.titulo = "Crear ";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirModalEditar(idConsPerf) {
      this.modalWindow = true;
      if (idConsPerf != null) {
        api.get("/vwconsperfs/" + idConsPerf)
          .then((resp) => {
            this.datoConsPerf = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar ";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    abrirEditar(idConsPerf) {
      if (idConsPerf != null) {
        this.$router.push("/consperfmd/" + idConsPerf);
      }
    },
    async deleteConsPerf(idConsPerf) {
      try {
        await api.delete("/consperfs/" + idConsPerf
        );
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
    fetchPerfils() {
      fetch(config.apiBaseUrl + "/perfils")
        .then((response) => response.json())
        .then((data) => {
          this.perfils = data;
        })
        .catch((error) => {
          console.error("Error fetching perfils:", error);
        });
    },
    fetchConsejos() {
      fetch(config.apiBaseUrl + "/consejos")
        .then((response) => response.json())
        .then((data) => {
          this.consejos = data;
        })
        .catch((error) => {
          console.error("Error fetching consejos:", error);
        });
    },
  },
};
</script>
